// Widget Scripts
import customSignupFeature from "./js/customSignupFeature.js";

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets if is required
if (window.location.pathname === '/') {
    $(document).ready(function () {
    });
};

// Initialize Custom Sign Up Feature
$(document).ready(function () {
  customSignupFeature();
});